export interface CountryNumber {
	isoCode: string;
	dialCode: string;
}

export const defaultCountries: CountryNumber[] = [
	{
		isoCode: 'SA',
		dialCode: '+966',
	},
];
